module.exports = __webpack_public_path__ + "static/media/deal-bogof.1f8cd1a6.png";